'use client';

import { c as _c } from "react/compiler-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@awesome.me/kit-94e593bf23/icons/sharp/light';

/**
 * SelectedFilters - Display active filters as removable chips
 *
 * Receives resolved filter objects (with names) and renders them as chips.
 * Clicking the X calls onRemoveFilter with the filter type and ID.
 */
export default function SelectedFilters(t0) {
  const $ = _c(24);
  const {
    resolvedFilters,
    onRemoveFilter,
    onClearAll
  } = t0;
  const {
    suppliers,
    designers,
    tags,
    price,
    sort
  } = resolvedFilters;
  const hasAnyFilters = suppliers?.length > 0 || designers?.length > 0 || tags?.length > 0 || price || sort;
  if (!hasAnyFilters) {
    return null;
  }
  let t1;
  if ($[0] !== onRemoveFilter || $[1] !== suppliers) {
    t1 = suppliers?.map(supplier => <FilterChip key={`supplier-${supplier.supplier_id}`} label={supplier.supplier_name} onRemove={() => onRemoveFilter("supplier", supplier.supplier_id)} />);
    $[0] = onRemoveFilter;
    $[1] = suppliers;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== designers || $[4] !== onRemoveFilter) {
    t2 = designers?.map(designer => <FilterChip key={`designer-${designer.designer_id}`} label={designer.designer_name} onRemove={() => onRemoveFilter("designer", designer.designer_id)} />);
    $[3] = designers;
    $[4] = onRemoveFilter;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== onRemoveFilter || $[7] !== tags) {
    t3 = tags?.map(tag => <FilterChip key={`tag-${tag.tag_id}`} label={tag.tag_name} onRemove={() => onRemoveFilter("tag", tag.tag_id)} />);
    $[6] = onRemoveFilter;
    $[7] = tags;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== onRemoveFilter || $[10] !== price) {
    t4 = price && <FilterChip label={price.label} onRemove={() => onRemoveFilter("price")} />;
    $[9] = onRemoveFilter;
    $[10] = price;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== onRemoveFilter || $[13] !== sort) {
    t5 = sort && <FilterChip label={sort.label} onRemove={() => onRemoveFilter("sort")} />;
    $[12] = onRemoveFilter;
    $[13] = sort;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== onClearAll) {
    t6 = onClearAll && <button type="button" onClick={onClearAll} className="text-2xs text-primary hover:underline ml-2">Clear All</button>;
    $[15] = onClearAll;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t1 || $[18] !== t2 || $[19] !== t3 || $[20] !== t4 || $[21] !== t5 || $[22] !== t6) {
    t7 = <div className="flex flex-wrap items-center gap-2">{t1}{t2}{t3}{t4}{t5}{t6}</div>;
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
}

/**
 * FilterChip - Individual filter chip with remove button
 */
function FilterChip(t0) {
  const $ = _c(8);
  const {
    label,
    onRemove
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <span>{label}</span>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FontAwesomeIcon icon={faXmark} className="text-2xs block" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onRemove) {
    t3 = <button onClick={onRemove} title="Remove Filter" className="absolute right-0.5 top-1/2 -translate-y-1/2 flex items-center justify-center w-5 h-5 rounded-full bg-primary text-white hover:bg-primary/80">{t2}</button>;
    $[3] = onRemove;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = <div className="group relative text-3xs rounded-full bg-gray-3 pl-3 pr-7 py-1 text-dark">{t1}{t3}</div>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}